// extracted by mini-css-extract-plugin
module.exports =  {"root":"QHiFq474N2vFLB9ZcybQ","label":"NJYQmqkdGVOJsx2LAzkP"};